import { Routes } from '@angular/router';
import { LandingComponent } from './features/landing/landing.component';
import { LoginComponent } from './features/auth/login.component';
import { ForgotPasswordComponent } from './features/auth/forgot-password.component';
import { ResetPasswordComponent } from './features/auth/reset-password.component';
import { OnboardUserComponent } from './features/auth/onboard-user.component';
import { UserProfileComponent } from './features/profile/user-profile.component';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { DsrListComponent } from './features/dsr/dsr-list.component';
import { DsrDetailComponent } from './features/dsr/dsr-detail.component';
import { ServiceCatalogComponent } from './features/services/service-catalog.component';
import { OnboardingComponent } from './features/onboarding/onboarding.component';
import { WorkflowsComponent } from './features/workflows/workflows.component';
import { UserManagementComponent } from './features/users/user-management.component';
import { AuditLogsComponent } from './features/audits/audit-logs.component';
import { ReportsComponent } from './features/reports/reports.component';
import { SlaManagementComponent } from './features/sla/sla-management.component';
import { AttachmentTypesComponent } from './features/attachments/attachment-types.component';
import { RoleManagementComponent } from './features/roles/role-management.component';
import { InstitutionListComponent } from './features/institutions/institution-list.component';
import { EngineConfigComponent } from './features/engine/engine-config.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: LandingComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'onboard-user/:token',
    component: OnboardUserComponent
  },
  {
    path: 'onbord-user/:token',
    component: OnboardUserComponent
  },
  {
    path: 'onboarding/complete',
    component: OnboardUserComponent
  },
  {
    path: 'onboarding',
    component: OnboardingComponent
  },
  {
    path: 'track-status',
    component: OnboardingComponent
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'profile', component: UserProfileComponent },
      { path: 'dsr', component: DsrListComponent },
      { path: 'dsr/:id', component: DsrDetailComponent },
      { path: 'services', component: ServiceCatalogComponent },
      { path: 'institutions', component: InstitutionListComponent },
      { path: 'onboarding', component: OnboardingComponent },
      { path: 'reports', component: ReportsComponent },
      { path: 'sla', component: SlaManagementComponent },
      { path: 'attachment-types', component: AttachmentTypesComponent },
      { path: 'roles', component: RoleManagementComponent },
      { path: 'workflows', component: WorkflowsComponent, data: { permission: 'can manage workflows' } },
      { path: 'users', component: UserManagementComponent, data: { permission: 'can assign role' } },
      { path: 'audits', component: AuditLogsComponent, data: { role: 'SuperAdmin' } },
      { path: 'engine', component: EngineConfigComponent },
      { path: 'engine/installation', component: EngineConfigComponent },
      { path: 'engine/security-server', component: EngineConfigComponent },
      { path: 'engine/configurations', redirectTo: 'engine/security-server', pathMatch: 'full' },
      { path: 'security-server', redirectTo: 'engine/security-server', pathMatch: 'full' },
      { path: 'configurations', redirectTo: 'engine/security-server', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: '' }
];

